export enum UseWindowsAuthenticationType {
  False = 0,
  True = 1,
}

export const useWindowsAuthenticationTypeDropdown = [
  UseWindowsAuthenticationType[UseWindowsAuthenticationType.True],
  UseWindowsAuthenticationType[UseWindowsAuthenticationType.False],
];
